import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl, setFormData, setFormDataV2, setFormDataV3 } from '../../../utils/network-utils';

@Injectable({
  providedIn: "root",
})
export class CorporateService {
  constructor(private http: HttpClient) {}

  getCorporateUsers(status): Observable<any> {
    return this.http
      .get<any>(
        urls.BASE_URL + urls.COPORATE_USER_LIST_URL + "?accountStatus=" + status
      )
      .pipe(catchError(errorHandl));
  }

  getCorporateUserById(id): Observable<any> {
    return this.http
      .get<any>(urls.BASE_URL + urls.COPORATE_USER_LIST_URL + "/" + id)
      .pipe(catchError(errorHandl));
  }

  addCorporateUser(data): Observable<any> {
    // Check for empty
    if (!(data.payorTypes && data.payorTypes.length)) {
      delete data.payorTypes;
    }
    const imageFiles = data.images;
    const corporateUserId = data.corporateUserId;
    delete data.images;
    delete data.corporateUserId;
    if (!(data.payorTypes && data.payorTypes.length) && !corporateUserId) {
      delete data.payorTypes;
    }
    let formData;
    if (!imageFiles.newProfilePicture) {
      formData = setFormDataV3({ ...data }, "cooperate");
    } else {
      formData = setFormDataV3({ ...data, ...imageFiles }, "cooperate");
    }
    // const formData = setFormData(imageFiles, data, 'cooperate');
    if (corporateUserId) {
      return this.http
        .put<any>(
          urls.BASE_URL + urls.COPORATE_USER_LIST_URL + "/" + corporateUserId,
          formData
        )
        .pipe(catchError(errorHandl));
    } else {
      return this.http
        .post<any>(urls.BASE_URL + urls.COPORATE_USER_LIST_URL, formData)
        .pipe(catchError(errorHandl));
    }
  }

  downloadExcel(payload) {
    return this.http
      .post<any>(urls.BASE_URL + urls.GET_CORPORATE_EXCEL_URL, payload)
      .pipe(catchError(errorHandl));
  }

  addConfiguration(payload, id) {
    if (id) {
      return this.http
        .put<any>(urls.BASE_URL + urls.SPACE_TYPE_MAPPERS + "/" + id, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http
        .post<any>(urls.BASE_URL + urls.SPACE_TYPE_MAPPERS, payload)
        .pipe(catchError(errorHandl));
    }
  }

  addCancelReason(payload, id) {
    if (id) {
      return this.http
        .put<any>(urls.BASE_URL + urls.CANCEL_REASON + "/" + id, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http
        .post<any>(urls.BASE_URL + urls.CANCEL_REASON, payload)
        .pipe(catchError(errorHandl));
    }
  }

  getChangeReasonById(id): Observable<any> {
    return this.http
      .get<any>(urls.BASE_URL + urls.CANCEL_REASON + "/" + id)
      .pipe(catchError(errorHandl));
  }

  getChangeReason() {
    return this.http
      .get<any>(urls.BASE_URL + urls.CANCEL_REASON)
      .pipe(catchError(errorHandl));
  }
  getChangeReasonByFundingSource(queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http
      .get<any>(urls.BASE_URL + urls.CANCEL_REASON + '/fundingsource', { params })
      .pipe(catchError(errorHandl));
  }

  getConfigurations() {
    return this.http
      .get<any>(urls.BASE_URL + urls.SPACE_TYPE_MAPPERS)
      .pipe(catchError(errorHandl));
  }

  getConfigurationsById(id): Observable<any> {
    return this.http
      .get<any>(urls.BASE_URL + urls.SPACE_TYPE_MAPPERS + "/" + id)
      .pipe(catchError(errorHandl));
  }

  getFundingSourceConfigurations(): Observable<any> {
    return this.http
      .get<any>(urls.BASE_URL + urls.FUNDING_SOURCE_CONFIGURATIONS)
      .pipe(catchError(errorHandl));
  }

  getFundingSourceConfigurationById(id): Observable<any> {
    return this.http
      .get<any>(urls.BASE_URL + urls.FUNDING_SOURCE_CONFIGURATIONS + "/" + id)
      .pipe(catchError(errorHandl));
  }

  addFundingSourceConfiguration(payload, id): Observable<any> {
    if (id) {
      return this.http
        .put<any>(urls.BASE_URL + urls.FUNDING_SOURCE_CONFIGURATIONS + "/" + id, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http
        .post<any>(urls.BASE_URL + urls.FUNDING_SOURCE_CONFIGURATIONS, payload)
        .pipe(catchError(errorHandl));
    }
  }
}
